import clsx from 'clsx';
import React from 'react';
import './SurveyParagraph.scss';

type SurveyParagraphProps = {
  className?: string;
};

export const SurveyParagraph: React.FC<SurveyParagraphProps> = ({ children, className }) => {
  return <div className={clsx('survey-paragraph', className)}>{children}</div>;
};
